export const EventLabelSeparatorConstant = '###';
export const VOICE_SEARCH_EVENT_TARGET = 'Voice Search';
export const SEARCH_BAR_EVENT_TARET = 'Search bar';
